export default __webpack_public_path__ + "static/media/wishlist.dfcfeb8a.png";